export default __webpack_public_path__ + "static/media/arrow-left.63261639.svg";